import { useState, useRef, useEffect } from "react";
import { LUNCH_URL } from "../../../../actions/api";
import { LIVE_API } from "../../../../actions/api";
import { shallowEqual, useSelector } from "react-redux";
import { FontAwesomeIcon } from "../../../CommonComponents/AssetsHelper";

const Embed = () => {

    const wallId = localStorage.getItem('wallId');
    const themeData = useSelector(state => state.appsMore,shallowEqual);

    const [copyTooltip, setcopyTooltip] = useState(false);
  
    const [embedWidth, setembedWidth] = useState(100);
    const [embedHeight, setembedHeight] = useState(100);
    const [embedWidthType, setembedWidthType] = useState('%');
    const [embedHeightType, setembedHeightType] = useState('%');

    const LinkRef = useRef();

    const copyCode = (data) => {

        navigator.clipboard.writeText(LinkRef.current.value)

        setcopyTooltip(true);
        setTimeout(() => {
            setcopyTooltip(false);
            document.getSelection().removeAllRanges();
        }, 1000);
    }

    useEffect(() => {
    }, [themeData])

    return (

        <>
            <div className="form-group mb-6">
                <h4 className="mb-6 font-weight-boldest">Steps To Display Social Wall In Virtual / Hybrid Events</h4>
                <p>Follow these steps to showcase the Taggbox Display social wall in virtual / hybrid events:</p>
            </div>

            <h5 className="mb-5">Step 1: (Choose As Per Platform Requirement)</h5>
            <div className="form-group mb-lg-10 mb-6">
                <h6 className="mb-4 ms-5 pt-2">A. Generate the embed code for Social Wall</h6>
                <div className="row ms-2">
                    <div className="col">
                        <div className="form-group mb-2">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">Width</span>
                                </div>
                                <input type="number" className="form-control form-control-lg" max={100} onKeyDown={e => (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()}
                                    data-factors-input-id="noform.field-22" value={embedWidth} min={1} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '').replace(/(\..*?)\..*/g, '$1')} onChange={(e) => setembedWidth(embedWidthType == 'px' ? e.target.value : (e.target.value > 100 ? 100 : e.target.value))} />
                                <div className="input-group-append">
                                    <select onChange={(e) => { setembedWidthType(e.target.value); setembedWidth(e.target.value == '%' && embedWidth > 100 ? 100 : embedWidth) }} className="kt-selectpicker form-control form-control-lg appearance-none py-0" id="embed-width">
                                        <option value="%">%</option>
                                        <option value="px">px</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="form-group mb-2">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">Height</span>
                                </div>
                                <input type="number" className="form-control form-control-lg" max={100} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '').replace(/(\..*?)\..*/g, '$1')}
                                    data-factors-input-id="noform.field-22" value={embedHeight} min={1} onChange={(e) => setembedHeight(embedHeightType == 'px' ? e.target.value : (e.target.value > 100 ? 100 : e.target.value))} />
                                <div className="input-group-append">
                                    <select onChange={(e) => { setembedHeightType(e.target.value); setembedHeight(e.target.value == '%' && embedHeight > 100 ? 100 : embedHeight) }} className="kt-selectpicker form-control form-control-lg appearance-none py-0" id="embed-height">
                                        <option value="%">%</option>
                                        <option value="px">px</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-group mb-6 mb-lg-10 ms-5">
                <p className="position-relative mb-0">
                    <textarea ref={LinkRef} onClick={(e) => { copyCode(1) }} readOnly="readonly" id="wallembedarea" style={{ height: '110px' }} className="form-control form-control-solid mb-2 copyme" value={`<div class="taggbox-container" style="${`width:${embedWidth}${embedWidthType};height:${embedHeight}${embedHeightType};overflow: auto;`}"><div class="taggbox-socialwall" data-wall-id="${wallId}" view-url="${`${LUNCH_URL}${wallId}`}"></div><script src="${LIVE_API ? `https://app.taggbox.com/` : `https://test.taggbox.com/`}display/js/embed.min.js" type="text/javascript"></script></div>`} /> <span id="copy-success-alert" style={{ display: copyTooltip ? 'block' : 'none' }}>Copied to clipboard</span>
                </p>
                <a className="text-underline text-link text-dark inst_guide" target="_blank" href="https://taggbox.com/support/embed-social-wall-in-virtual-event/#subTitle7" data-factors-click-bind="true">
                    Installation Guide
                    <FontAwesomeIcon type={'light'} icon={'angle-right'} iconClass={'fs-4'} />
                </a>
            </div>
        </>
    )

}

export default Embed